import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	titleJpdRoadmaps: {
		defaultMessage: 'Roadmaps',
		id: 'atlassian-navigation.roadmaps.title-jpd-roadmaps',
		description: 'Title of the JPD roadmaps menu item.',
	},
});
